<template>
    <div>
        <textarea id="inputCode" cols="250" rows="30" v-model="inputCode" @input="analysys()"></textarea>
        <div class="result" v-for="(item, index) in result">{{ item }}</div>
    </div>
</template>

<script>
    export default {
        name: "LeakCheck",
        data() {
            return {
                inputCode: '',
                result: [],
            }
        },
        methods: {
            analysys() {
                const rows = this.inputCode.split('\n');
                rows.forEach(r => {
                    if (r.includes('.subscribe(')) {
                        this.result.push(r);
                    }
                });
            },
        }
    }
</script>

<style scoped>
    div.result {
       text-align: left; 
    }
</style>